import { Injectable } from '@angular/core';
import { BehaviorSubject, throwError } from 'rxjs';
import { Observable } from 'rxjs';
import { Logger } from '../monitoring/logger/logger';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class ErrorHandlingService {

  public errors: Observable<any>;
  private _errors: BehaviorSubject<any>;

  constructor(private logger: Logger) {
    this._errors = new BehaviorSubject<any>(null);
    this.errors = this._errors.asObservable();
  }

  public handleError = (error: HttpErrorResponse) => {
    this.logger.error(error.message);
    if (error.error) {
      this.logger.error(error.error);
    }

    this._errors.next(error);
    return throwError(error);
  }
}
